export default __webpack_public_path__ + "static/media/logo.54a9b9cb.svg";